/* eslint-disable react/jsx-indent */
import * as React from "react";

import { useMediaQuery, useTheme } from "@material-ui/core";
import clsx from "clsx";
import Slider from "react-slick";

const AgapeSlider = ({
  children,
  className,
  infinite = false,
  autoplay = false,
  dots = false,
  arrow = false,
  autoplaySpeed = 5000,
  speed = 500,
  slidesToShowDesktop = 4,
  slidesToShowTablet = 1,
  slidesToShowMobile = 1,
  slidesToScroll = 1,
  listLength = slidesToShowDesktop,
  ...props
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const settings = {
    dots,
    infinite:
      infinite && isMobile
        ? listLength > slidesToShowMobile
        : infinite && isTablet
        ? listLength > slidesToShowTablet
        : listLength > slidesToShowDesktop,
    autoplay,
    autoplaySpeed,
    speed,
    slidesToShow: isMobile
      ? slidesToShowMobile
      : isTablet
      ? slidesToShowTablet
      : slidesToShowDesktop,
    slidesToScroll,
    className: clsx(
      "agape__slider__component",
      arrow && "agape__slider__component__arrow",
      className
    ),
    arrow,
  };

  return <Slider {...settings}>{children}</Slider>;
};

export default AgapeSlider;
// موسسات پیشنهادی به شما
